import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { SettingsPage, TAB_ORDER } from "#/pages/settings";

const settingsSearchSchema = z.object({
  // 旧 chatbox、scenarios 等历史值和非法值落回默认的 Appearance；缺失时也默认打开它。
  tab: z.enum(TAB_ORDER).catch("appearance").default("appearance"),
});

export const Route = createFileRoute("/_console/settings")({
  component: SettingsRoute,
  validateSearch: settingsSearchSchema,
  beforeLoad: ({ location, search }) => {
    if (new URLSearchParams(location.searchStr).get("tab") !== search.tab) {
      throw redirect({
        to: "/settings",
        search: { tab: search.tab },
        replace: true,
      });
    }
  },
});

/** 当前标签是路由状态：刷新和前进后退都要回到同一个标签（PRD 4.1）。 */
function SettingsRoute() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <SettingsPage
      onTabChange={(next) => {
        void navigate({ search: { tab: next } });
      }}
      tab={tab}
    />
  );
}
